import React, { useRef, useState, useEffect } from "react";
import Lottie from "react-lottie-player";

const PodcastPlayer = ({ playlist, currentPodcast }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [animationData, setAnimationData] = useState(null);
  const audioRef = useRef(null);

  useEffect(() => {
    fetch("/animations/music-playing.json")
      .then((response) => {
        console.log("Response status:", response.status);
        console.log("Response content type:", response.headers.get("content-type"));
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log("Loaded Lottie JSON:", data);
        setAnimationData(data);
      })
      .catch((error) => console.error("Error loading Lottie JSON:", error));
  }, []);

  useEffect(() => {
    if (currentPodcast && audioRef.current) {
      const audio = audioRef.current;
      audio.src = currentPodcast.trackUrl;
      audio
        .play()
        .then(() => setIsPlaying(true))
        .catch((err) => console.error("Error playing audio:", err));
    }
  }, [currentPodcast]);

  const handlePlayPause = () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (isPlaying) {
      audio.pause();
      setIsPlaying(false);
    } else {
      audio
        .play()
        .then(() => setIsPlaying(true))
        .catch((err) => console.error("Error playing audio:", err));
    }
  };

  return (
    <div className="fixed bottom-0 left-0 w-full bg-gray-100 border-t p-4 shadow-lg flex items-center justify-between">
      {/* Lottie Animation */}
      {animationData && (
        <div className="flex items-center">
          <Lottie
            loop
            animationData={animationData}
            play={isPlaying} // Only play animation when the podcast is playing
            style={{ width: 50, height: 50 }}
          />
          <div className="ml-4">
            <h3 className="text-lg font-bold">{currentPodcast?.name || "No Podcast Selected"}</h3>
            <p className="text-gray-500">{currentPodcast?.artist || ""}</p>
          </div>
        </div>
      )}

      {/* Controls */}
      <div className="flex items-center space-x-4">
        <button
          onClick={handlePlayPause}
          className="px-4 py-2 bg-blue-500 text-white rounded-md"
        >
          {isPlaying ? "Pause" : "Play"}
        </button>
      </div>

      {/* Hidden Audio Element */}
      <audio ref={audioRef}></audio>
    </div>
  );
};

export default PodcastPlayer;
